"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronLeft = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var locations = {
  page: '/pages',
  article: '/articles',
  blog: '/articles',
  template: '/templates',
  element: '/elements'
};

var BackButton = function BackButton(_ref) {
  var _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === void 0 ? 'page' : _ref$contentType;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "back",
    to: locations[contentType],
    "data-testid": "navigate-back"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faChevronLeft.faChevronLeft
  }));
};

var _default = BackButton;
exports["default"] = _default;